export const MINI_APPID_HZW_MALL = 'wx38c03f55ea0ab651' // 孩子王
export const MINI_APPID_XYZHG = 'wx09a5336efa0e5680' // 幸孕中国
export const MINI_APPID_TCHQZ = 'wxffd73aa1225d87d6' // 同城亲子
